import EnquiriesManagement from '../EnquiriesManagement';

const PartnersEnquiries = () => {
  return <EnquiriesManagement serviceType="partner" />;
};

export default PartnersEnquiries;